<template>
    <div class="body-panel">
        <div class="body-panel-content">
            <div class="body-panel-content-start flex">
                <div class="login-page-bg">
                </div>
                <div class="login-page">
                    <div class="login-logo" v-if="info.StartImage != null">
                        <img class="login-logo-img" :src="info.StartImage" />
                    </div>
                    <div class="login">
                        <div class="form-header">
                            Авторизация
                        </div>
                        <div class="form-field">
                            <input class="input-text" id="UserName" name="UserName" placeholder="Логин или email" type="text"
                                   v-validate="'required'"
                                   v-model="UserName"
                                   data-vv-as="Логин"
                                   :class="['input-text', {'input-error': errors.has('UserName')}]"
                                   @input="error = null" />
                            <span class="field-validation-valid">{{ errors.first('UserName') }}</span>
                        </div>
                        <div class="form-field password-field">
                            <input :type="showPassword ? 'text' : 'password'" class="input-text" id="Password" name="Password" placeholder="Пароль"
                                   v-validate="'required'"
                                   v-model="Password"
                                   data-vv-as="Пароль"
                                   :class="['input-text', {'input-error': errors.has('Password')}]"
                                   @keyup.enter="logIn" />
                            <span class="toggle-password" @click="togglePasswordVisibility">
                                <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                            </span>
                            <span class="field-validation-valid">{{ errors.first('Password') }}{{error}}</span>
                        </div>
                        <div class="form-actions">
                            <input id="rememberMe" name="rememberMe" value="true" type="checkbox" checked class="input-checkbox" />
                            <label for="rememberMe" class="input-checkbox-lbl">Запомнить</label>
                            <router-link to="/forgot" class="forgot-password">Забыли пароль?</router-link>
                            <div class="form-btns btns">
                                <button type="submit" class="btn btn-primary auth" @click="logIn">
                                    Войти
                                </button>
                            </div>
                            <div class="margin-top-10 flex" v-if="external.length > 0">
                                <p style="font-size:16px;color:#8198AE;width:100%">или войдите через</p>
                                <div class="external-items margin-left-10" style="white-space:nowrap">
                                    <a :href="provider.attachLink" v-for="provider of external">
                                        <i :class="provider.cssClass" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="reglink margin-top-20" v-if="info.RegisterSettings.Enabled">
                                <p>Не зарегистрированы? <span @click="$router.push('/register')">Регистрация</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vue-headful title="Авторизация" />
    </div>
</template>

<script>

  import UI from '../helpers/ui-helpers'
  import config from '../config'
  import BackendApi from '../backendApi'

  let backendApi = new BackendApi();

  let tokenKey = "tokenInfo";
  export default {
      name: "login",

      props: ['info'],

      data(){
          return{
              UserName: null,
              Password: null,
              error: null,
              external:[],
              vkLoginHref: null,
              showPassword: false // состояние для видимости пароля
          }
      },

      methods: {
          logIn() {
              let vm = this;

              this.$validator.validate().then(result => {
                  if(result){
                      let loginData = {
                          grant_type: 'password',
                          username: vm.UserName,
                          password: vm.Password,
                          isMobile: false
                      };

                      vm.error = null;
                      $.ajax({
                          type: 'POST',
                          url: config.apiUrl + '/Token',
                          data: loginData,
                          success: function (data) {
                              vm.processSuccessLogin(data);
                          },
                          error: function (data) {
                              vm.processErrorLogin(data);
                          }
                      });
                  }
              });

          },

          processSuccessLogin(data){
              console.info('processSuccessLogin ->', data.userName);
              $('.userName').text(data.userName);
              $('.userInfo').css('display', 'block');
              $('.loginForm').css('display', 'none');

              localStorage.removeItem(tokenKey);
              sessionStorage.removeItem(tokenKey);
              localStorage.removeItem('cart');
              localStorage.removeItem('usersComplexFilter');
              localStorage.removeItem('selectedProjectId');

              if ($('#rememberMe').is(':checked')) {
                  localStorage.setItem(tokenKey, JSON.stringify(data));
              } else {
                  sessionStorage.setItem(tokenKey, JSON.stringify(data));
              }

              localStorage.setItem('firstLogin', 'true');

              console.info('processSuccessLogin -> redirect');
              location.href = '/';
          },

          processErrorLogin(data){
              let vm = this;

              console.info(data.responseJSON)
              if (data.responseJSON.error === 'invalid_grant') {
                  vm.error = 'Неверные имя пользователя или пароль';
              }
              else if (data.responseJSON.error === 'user_blocked') {
                  vm.error = 'Ваш аккаунт заблокирован. Обратитесь в службу поддержки';
              }
              else if (data.responseJSON.error === 'email_notconfirmed') {
                  vm.error = 'Вам отправлено сообщение. Пожалуйста, пройдите по ссылке для завершения регистрации.';
              }
              else if (data.responseJSON.error === 'user_needapprovement') {
                  vm.error = 'В ближайшее время Ваши данные проверит Администратор, после чего Вы получите уведомление на Email и сможете авторизоваться.';
              }
              else if (data.responseJSON.error === 'user_refused') {
                  let err = 'Вам отказано в регистрации.';
                  if (data.responseJSON.error_description) {
                      err = `${err} Причина отказа: ${data.responseJSON.error_description}`;
                  }
                  vm.error = err;
              }
              else {
                  UI.toastr.error('При логине возникла ошибка');
              }
          },

          togglePasswordVisibility() {
              this.showPassword = !this.showPassword;
          }
      },

      mounted() {
          let vm = this;

          let externalLoginStatus = vm.$route.query.externalLoginStatus;

          if(externalLoginStatus){
              if(externalLoginStatus == 200) {
                  let token = vm.$route.query.token,
                      userName = vm.$route.query.userName;
                  vm.processSuccessLogin({
                      userName: userName,
                      access_token: token
                  });

                  return;
              }
              else{
                  UI.toastr.error(externalLoginStatus == 404 ? 'Пользователь не найден' : 'Возникла ошибка. Обратитесь к администратору');

                  let query = Object.assign({}, vm.$route.query);
                  delete query.externalLoginStatus;
                  vm.$router.replace({ query });
              }

          }

          let baseHost = location.origin;
          if(baseHost.indexOf('localhost') > -1 && config.apiUrl){
              baseHost = config.apiUrl;
          }
          let redirectUri = `${baseHost}/External/Login/?provider=%provider%`;

          if (vm.info.ExternalVk) {
              vm.external.push({
                  providerName: 'Vk',
                  cssClass: 'fa fa-vk fa-2x',
                  attachLink: "https://oauth.vk.com/authorize" +
                      "?client_id=" + encodeURIComponent(config.vkAppId) +
                      "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'vk')) +
                      "&scope=" + encodeURIComponent(config.vkAppScopes) +
                      "&response_type=code" + "&v=" + encodeURIComponent(config.vkVersion)
              });
          }
          if (vm.info.ExternalGoogle) {
              vm.external.push({
                  providerName: 'Google',
                  cssClass: 'fa fa-google fa-2x',
                  attachLink: "https://accounts.google.com/o/oauth2/auth" +
                      "?client_id=" + encodeURIComponent(config.googleAppId) +
                      "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'google')) +
                      "&access_type=offline&prompt=consent" +
                      "&scope=" + encodeURIComponent(config.googleAppScopes) +
                      "&response_type=code"
              });
          }
          //if (vm.info.ExternalFacebook) {
          //    vm.external.push({
          //        providerName: 'Facebook',
          //        cssClass: 'fa fa-facebook fa-2x',
          //        attachLink: "https://www.facebook.com/dialog/oauth" +
          //            "?client_id=" + encodeURIComponent(config.facebookAppId) +
          //            "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'facebook')) +
          //            "&scope=" + encodeURIComponent(config.facebookAppScopes) +
          //            "&response_type=code"
          //    });
          //}
      }

  }
</script>


<style scoped>
    .external-items a{
        display: inline-block;
        margin-right: 15px;
    }

    .password-field {
        position: relative;
    }

    .toggle-password {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
    }

    .fa-eye, .fa-eye-slash {
        font-size: 1.6em;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/Login.vue